import StaffMemberJobItem from './StaffMemberJobItem.container';

export default StaffMemberJobItem;
